
import { motion } from "framer-motion";

interface ChatLoadingStateProps {
  message?: string;
}

export const ChatLoadingState = ({ message = "Loading chat..." }: ChatLoadingStateProps) => {
  return (
    <div className="flex flex-col h-[calc(100vh-16rem)] md:h-[500px] bg-muted/95 backdrop-blur-md rounded-lg relative border border-gray-800/50">
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="flex flex-col items-center space-y-8 px-4 text-center">
          <div className="relative w-20 h-20">
            <motion.div
              className="absolute inset-0 rounded-full border-4 border-primary/30 animate-gpu"
              animate={{
                scale: [1, 1.2, 1],
                opacity: [0.3, 0.6, 0.3],
              }}
              transition={{
                duration: 2,
                repeat: Infinity,
                ease: "easeInOut",
              }}
              style={{
                willChange: "transform, opacity",
                backfaceVisibility: "hidden",
              }}
            />
            <motion.div
              className="absolute inset-0 rounded-full border-4 border-t-primary border-r-primary border-b-transparent border-l-transparent animate-gpu"
              animate={{ 
                rotate: 360 
              }}
              transition={{
                duration: 1.5,
                repeat: Infinity,
                ease: "linear",
              }}
              style={{
                willChange: "transform",
                backfaceVisibility: "hidden",
              }}
            />
          </div>
          <div className="space-y-2">
            <motion.p
              className="text-muted-foreground text-lg font-medium"
              animate={{
                opacity: [0.5, 1, 0.5],
              }}
              transition={{
                duration: 2,
                repeat: Infinity,
                ease: "easeInOut",
              }}
              style={{
                willChange: "opacity",
              }}
            >
              {message}
            </motion.p>
            <p className="text-sm text-muted-foreground/80">
              This may take a few moments
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
